import { render, staticRenderFns } from "./LoteTitulo.vue?vue&type=template&id=2be60dfe"
import script from "./LoteTitulo.vue?vue&type=script&lang=js"
export * from "./LoteTitulo.vue?vue&type=script&lang=js"
import style0 from "./LoteTitulo.vue?vue&type=style&index=0&id=2be60dfe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports